module.exports = __webpack_public_path__ + "img/Latona.eda12bf0.png";